export const PreparerExternalList = {
    KEPT: {
        "epsgeneral":
            [
                {
                    "type": "menu",
                    "title": "Notifications",
                    "icon": "notifications_active",
                    "materialicon": "notifications_active",
                    "link": "/notifications",
                    "key": "Notifications",
                    "style": {
                        'color': '#d50000'
                    }
                },

                {
                    "type": "menu",
                    "title": "Records",
                    "key": "newapplicationdetails",
                    "link": "#/Records/RECYCLERS",
                    "icon": "fa fa-file-text",
                    "materialicon": "new_releases",
                    "style": {
                        'color': '#9c27b0'
                    }
                },
                {
                    "type": "menu",
                    "title": "Contacts",
                    "key": "contacts",
                    "link": "#/Administration/externalcontacts",
                    "icon": "fa fa-user-circle-o",
                    "materialicon": "contacts",
                    "style": {
                        'color': '#006064'
                    }
                }
            ],
    },
    AMES: {
        "epsgeneral":
            [
                {
                    "type": "menu",
                    "title": "Notifications",
                    "icon": "notifications_active",
                    "materialicon": "notifications_active",
                    "link": "#/notifications",
                    "key": "Notifications",
                    "style": {
                        'color': '#d50000'
                    }
                },

                {
                    "type": "menu",
                    "title": "Records",
                    "key": "newapplicationdetails",
                    "link": "#/Records/RECYCLERS",
                    "icon": "fa fa-file-text",
                    "materialicon": "new_releases",
                    "style": {
                        'color': '#9c27b0'
                    }
                },
                {
                    "type": "menu",
                    "title": "Contacts",
                    "key": "contacts",
                    "link": "#/Administration/externalcontacts",
                    "icon": "fa fa-user-circle-o",
                    "materialicon": "contacts",
                    "style": {
                        'color': '#006064'
                    }
                }
            ],
    },
    LAOACS: {
        "epsgeneral":
            [
                {
                    "type": "menu",
                    "title": "Notifications",
                    "icon": "notifications_active",
                    "materialicon": "notifications_active",
                    "link": "#/notifications",
                    "key": "Notifications",
                    "style": {
                        'color': '#d50000'
                    }
                },
                {
                    "type": "menu",
                    "title": "Invoice Dashboard",
                    "icon": "assessment",
                    "materialicon": "assessment",
                    "link": "/billingdashboard",
"reloadtab": true,
                    "key": "billingdashboard",
                    "style": {
                        'color': '#c158dc'
                    }
                },
                {
                    "type": "menu",
                    "title": "Search",
                    "icon": "search",
                    "materialicon": "search",
                    "link": "/search",
"reloadtab": true,
                    "key": "Search",
                    "style": {
                        'color': '#61A5DC'
                    }
                },],
        "myportallist":
            [
                {
                    "type": "menu",
                    "title": "Records",
                    "key": "newapplicationdetails",
                    "link": "#/Records/RECYCLERS",
                    "icon": "fa fa-file-text",
                    "materialicon": "new_releases",
                    "style": {
                        'color': '#9c27b0'
                    }
                },
                // {
                //     "type": "menu",
                //     "title": "Contacts",
                //     "key": "contacts",
                //     "link": "#/Administration/externalcontacts",
                //     "icon": "fa fa-user-circle-o",
                //     "materialicon": "portrait",
                //     "style": {
                //         'color': '#006064'
                //     }
                // }
            ],
    },
}


